import { render, staticRenderFns } from "./DataTableItemSeconds.vue?vue&type=template&id=0f58eb5c&"
import script from "./DataTableItemSeconds.vue?vue&type=script&lang=ts&"
export * from "./DataTableItemSeconds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports